<template>
  <v-container class="grey lighten-5">
    <v-row justify="center">
      <div class="signin">
        <div v-if="!signedIn">
          <amplify-auth-container>
            <amplify-authenticator
              v-bind:authConfig="authConfig"
            ></amplify-authenticator>
          </amplify-auth-container>
        </div>
        <div v-if="signedIn">
          <amplify-sign-out></amplify-sign-out>
        </div>
      </div>
    </v-row>
  </v-container>
</template>
<script>
import { AmplifyEventBus } from "aws-amplify-vue";
import { Auth } from "aws-amplify";
export default {
  name: "SignIn",
  data() {
    return {
      signedIn: false,
      authConfig: {
        signUpConfig: {
          hideAllDefaults: true,
          defaultCountryCode: "81",
          signUpFields: [
            {
              label: "Username",
              key: "username",
              required: true,
              displayOrder: 1,
              type: "string",
            },
            {
              label: "Email",
              key: "email",
              required: true,
              displayOrder: 2,
              type: "string",
            },
            {
              label: "Password",
              key: "password",
              required: true,
              displayOrder: 3,
              type: "password",
            },
          ],
        },
      },
    };
  },
  async beforeCreate() {
    try {
      await Auth.currentAuthenticatedUser();
      this.signedIn = true;
    } catch (err) {
      this.signedIn = false;
    }
    AmplifyEventBus.$on("authState", (info) => {
      if (info === "signedIn") {
        this.signedIn = true;
      } else {
        this.signedIn = false;
      }
    });
  },
};
</script>
<style>
.signin {
  margin: 20px;
}
input {
  font-size: 16px !important;
}
@media screen and (max-width: 480px) {
  .signin div {
    min-width: 0;
  }
}
</style>
